import { useState, useEffect } from "react";
import { Divider } from "antd";
import { Users } from "lucide-react";
import { getRequest } from "../../service";

import {
  LeaveHistory,
  Assets,
  Document,
  Leave,
} from "./tabs";

const ReportCard = (props) => {

  const [activeTab, setActiveTab] = useState("Leave");
  const [leaveData, setLeaveData] = useState(null);
  const {employeeId, leaveId} = props;
  const tabButtons = [
    "Leave",
    "Leave History", 
    "Documents",
    "Assets",
  ];


  useEffect(() => {
    const fetchLeaveData = async () => {
      try {
        const response = await getRequest('/api/leaves');
        if (response?.leaveConfigs) {
          // Filter leave configs based on leaveId if provided
          const filteredLeaves = leaveId 
            ? response.leaveConfigs.filter(leave => leaveId.includes(leave._id))
            : response.leaveConfigs;
          setLeaveData(filteredLeaves);
        }
      } catch (error) {
        console.error('Error fetching leave data:', error);
      }
    };

    fetchLeaveData();
  }, [leaveId]);

  const tabs = {
    Leave: <Leave leaveData={leaveData} />,
    "Leave History": <LeaveHistory employeeId={employeeId}/>,
    Documents: <Document employeeId={employeeId}/>,
    Assets: <Assets employeeId={employeeId}/>,
  };

  return (
    <div className="w-full rounded-lg border-t-[#231564] border-2 border-form-bg shadow-lg py-3 bg-white">
      {/* Reporting Team Section */}
      <div className="px-3">
        <div className="flex items-center gap-2 text-black font-semibold">
          <Users size={20} />
          <h2 className="text-md font-semibold pt-3">REPORTING TEAM </h2>
        </div>
      </div>
      <Divider className="!p-0 !m-0" />
      
      {/* Tabs Section */}
      <div className="mt-4">
        <div className="flex flex-wrap items-center gap-3 text-md bg-[#231564] py-1 rounded-md px-3 font-medium">
          {tabButtons.map((btn) => (
            <button
              key={btn}
              onClick={() => setActiveTab(btn)}
              className={`px-4 whitespace-nowrap py-1.5 rounded-md border-none text-white ${
                btn !== activeTab && "cursor-pointer"
              } ${activeTab === btn && "bg-[#5947ad]"}`}
            >
              {btn}
            </button>
          ))}
        </div>
      </div>

      {/* Content Section */}
      <div className="mt-4">
        {tabs[activeTab]}
      </div>
    </div>
  );
};

export default ReportCard;
